module.exports = __webpack_public_path__ + "static/img/bonus_5.665b851.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zeus/bonus_5.png
// module id = 7f8V
// module chunks = 0